import { Box, Card, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import NotificationList from '../components/NotificationList';
import { NoRecordFound, Pagination, STableLoader } from '../../../../shared_elements';
import { globalBetaGetService } from '../../../../utils/globalApiServices';
import { getNotificationApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import DiscriptionModal from '../components/DiscriptionModal';

const NotificationTableHeader=({ createSortHandler, sortInfo, toggleBulkOps, item, bulk })=>{
 const tableSorting = (key, name, disableSort = false) => (
    <TableSortLabel
      disabled={disableSort}
      hideSortIcon={disableSort}
      sx={{ whiteSpace: "nowrap" }}
      active={sortInfo?.sort_by === key}
      direction={sortInfo?.sort_by === key ? (sortInfo?.sort || "asc").toLowerCase() : "asc"}
      onClick={() => createSortHandler(key)}
    >
      {name}
    </TableSortLabel>
  );

  return (
      <TableHead>
      <TableRow>
        {/* <TableCell
          sx={{
            position: 'sticky',
            left: 0,
            backgroundColor: 'inherit',
            zIndex: 11,
          }}
        >
          <Checkbox
            color="primary"
            size="small"
            onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, item)}
            checked={item?.length === bulk?.ids?.length && item?.length > 0}
          />
        </TableCell>
        <TableCell
          sx={{
            minWidth: '140px',
            position: 'sticky',
            left: 58,
            backgroundColor: 'inherit',
            zIndex: 11,
          }}
        >
          Action(s)
        </TableCell> */}
        <TableCell>{tableSorting("type", "Type",true) }</TableCell>
        <TableCell>{tableSorting("subject", "Subject",true)}</TableCell>
        <TableCell>{tableSorting("date", "Date",true)}</TableCell>
        <TableCell>{tableSorting("status", "Status",true)}</TableCell>
      </TableRow>
    </TableHead>
  )


}


const Notification = () => {
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [notificationInfo,setNotificationInfo]=useState()
    const  [isReadMore, setIsReadMore] = useState({ mode: '', modal: false, data: null });
     
    useEffect(() => {
        getNotificationList('skeletonLoader', { per_page: 20 });
    }, []);

    const getNotificationList = (loaderType, query = {}) => {
       setSkeletonLoader(true)
        globalBetaGetService(getNotificationApi({per_page:20,timestamp: Date.now()})).then(response => {
          if (checkApiStatus(response)) {
           setSkeletonLoader(false);
            setNotificationInfo(response.data.data);
          } else {
            setSkeletonLoader(false);
          }
        })
      };
     return (
    <>
    <Card sx={{padding:"5px 5px 5px 5px",marginBottom:"15px"}}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid size={{ md: 6, xs: 12 }}>
         <Typography color='primary' fontSize={"20px"}>Notification</Typography>
            </Grid>
          <Grid size={{ md: 6, xs: 12 }}  sx={{ display:"flex",justifyContent:"flex-end"}}>
        </Grid>
      </Grid>
    </Card>
     <Box className="lease-detail-table">
        {
            skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                <div>
                  <Paper style={{ maxHeight: `${window.innerHeight - 265}px`, overflow: 'scroll' }}>
                    <Table className="mui-table-format" stickyHeader>
                      <NotificationTableHeader  />
                      <TableBody>
                        {notificationInfo?.notifications?.length > 0 ? notificationInfo?.notifications?.map((item, index) =>
                          <NotificationList
                            key={index}
                            item={item}
                            readMore={() => setIsReadMore({ modal: true, data: item, mode: 'view' })}
                          />
                        ) : <NoRecordFound />}
                      </TableBody>
                    </Table>
                  </Paper>
                  <Paper>
                    <Pagination
                      pagination={notificationInfo?.pagination}
                      onPageChange={(event, newPage) => { const pageNum = newPage + 1; getNotificationList('pageLoader', { page: pageNum, per_page: notificationInfo.pagination.per_page, }); }}
                      onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value); getNotificationList('pageLoader', { page: 1, per_page: perPage, }); }}
                    />
                  </Paper>
                </div>
              )
            }
         </Box>
         {
        isReadMore.modal && 
        <DiscriptionModal
         data={isReadMore?.data}
         onToggleModal={() => setIsReadMore({ modal: false, data: null, mode: '' })}
        />
       }
    </>
   
  )
}

export default Notification